export default [
  { label: 'Not started', value: null },
  { label: 'In Progress', value: 'inprogress', backgroundColor:'#F8F0FF', color: '#8A53FF'},
  { label: 'Submitted', value: 'submitted', backgroundColor:'#F2F5FE', color: '#547FF6' },
  { label: 'Denied', value: 'denied', backgroundColor:'#FFEFF4', color: '#E62565' },
  { label: 'Waitlisted', value: 'waitlist', backgroundColor:'#FDECFF', color: '#AF22AA' },
  { label: 'Deferred', value: 'deferred', backgroundColor:'#FEF9EF', color: '#F79900' },
  { label: 'Accepted', value: 'accepted', backgroundColor:'#E3FFF5', color: '#25C186' },
  { label: 'Enrolled', value: 'enrolled', backgroundColor:'#F5FCF0', color: '#87CF50' },
]
